/**
 * Tiny inline SVG icon set. Avoids pulling a 200KB icon library for the
 * ~10 glyphs the dashboard actually uses. Stroke-based, currentColor.
 */
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement>;

const base = (path: string) => (props: Props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    dangerouslySetInnerHTML={{ __html: path }}
  />
);

export const IconSearch = base(
  '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>',
);
export const IconRefresh = base(
  '<path d="M3 12a9 9 0 0 1 15-6.7L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-15 6.7L3 16"/><path d="M3 21v-5h5"/>',
);
export const IconBolt = base(
  '<path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z"/>',
);
export const IconUsers = base(
  '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
);
export const IconActivity = base(
  '<path d="M22 12h-4l-3 9L9 3l-3 9H2"/>',
);
export const IconClock = base(
  '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
);
export const IconAlert = base(
  '<path d="m21.7 16.5-7.7-13a2 2 0 0 0-3.5 0l-7.7 13A2 2 0 0 0 4.5 19.5h15a2 2 0 0 0 1.7-3"/><path d="M12 9v4"/><path d="M12 17h0"/>',
);
export const IconChevronRight = base('<path d="m9 18 6-6-6-6"/>');
export const IconChevronLeft = base('<path d="m15 18-6-6 6-6"/>');
export const IconLogOut = base(
  '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" x2="9" y1="12" y2="12"/>',
);
export const IconX = base('<path d="M18 6 6 18"/><path d="m6 6 12 12"/>');
export const IconExternal = base(
  '<path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>',
);
export const IconGlobe = base(
  '<circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a13.5 13.5 0 0 1 0 18"/><path d="M12 3a13.5 13.5 0 0 0 0 18"/>',
);
export const IconSettings = base(
  '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>',
);
